import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class CadastroLoteKeys extends MainKeys {
    public get place() {
        return Places.cadastroLote
    }

    /** Mantém o lote aberto na URL, para recarregar a página sem perder o acompanhamento. */
    public get loteId() {
        return this._intent.getParameterAsString('lote') ?? ''
    }

    public set loteId(value: string) {
        this._intent.setParameter('lote', value || null)
    }
}

export default CadastroLoteKeys
